export function geofencesJson (language) {
  let items

  if (language === 'es') {
    items = {
      newGeocerca: {
        name: 'newGeocerca',
        label: 'crear una geocerca'
      },
      removeGeocercas: {
        name: 'removeGeocercas',
        label: 'eliminar geocercas'
      },
      seeInformationGeocerca: {
        name: 'seeInformationGeocerca',
        label: 'acceder a la información de las geocercas'
      },
      editGeocerca: {
        name: 'editGeocerca',
        label: 'editar geocercas'
      }
    }
  } else if (language === 'en') {
    items = {
      newGeocerca: {
        name: 'newGeocerca',
        label: 'create a geofence'
      },
      removeGeocercas: {
        name: 'removeGeocercas',
        label: 'delete geofences'
      },
      seeInformationGeocerca: {
        name: 'seeInformationGeocerca',
        label: 'access geofence information'
      },
      editGeocerca: {
        name: 'editGeocerca',
        label: 'edit geofences'
      }
    }
  }
  return (items)
}
